import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { CatalogLostStrandTypesReducer } from "./CatalogLostStrandTypesReducer";

const CatalogLostStrandTypesContext = createContext({
	state: CatalogLostStrandTypesReducer.getInitialState(),
	actions: CatalogLostStrandTypesReducer.actions,
});

export const useCatalogLostStrandTypesContext = () =>
	useContext(CatalogLostStrandTypesContext);

export const CatalogLostStrandTypesProvider = ({
	children,
}: {
	children: ReactNode;
}) => {
	const [state, actions] = useComplexState({
		initialState: CatalogLostStrandTypesReducer.getInitialState(),
		reducers: CatalogLostStrandTypesReducer.caseReducers,
	});
	return (
		<CatalogLostStrandTypesContext.Provider value={{ state, actions }}>
			{children}
		</CatalogLostStrandTypesContext.Provider>
	);
};
